var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDescReg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49602 12L13.544 11.9982L13.6303 11.9832L13.6926 11.9622L13.7513 11.9333L13.8131 11.8911L13.8706 11.8373L13.9113 11.7867L13.946 11.7292L13.9783 11.6512L13.9898 11.6081L14.0011 11.5217L14.0015 6.5C14.0015 6.22386 13.7777 6 13.5015 6C13.2561 6 13.0519 6.17688 13.0096 6.41013L13.0015 6.5L13.001 10.293L7.85782 5.14653C7.68439 4.97302 7.41516 4.95358 7.22027 5.08832L7.151 5.14608L5.50037 6.79326L2.85355 4.14645C2.65829 3.95118 2.34171 3.95118 2.14645 4.14645C1.97288 4.32001 1.9536 4.58944 2.08859 4.78431L2.14645 4.85355L5.14645 7.85355C5.31988 8.02699 5.58907 8.04639 5.78393 7.91167L5.85318 7.85392L7.50374 6.20682L12.293 11H8.49602C8.25056 11 8.04642 11.1769 8.00408 11.4101L7.99602 11.5C7.99602 11.7761 8.21988 12 8.49602 12Z",
    fill: "#E53935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDescReg);
export default __webpack_public_path__ + "static/media/ArrowDescReg.85ff84b898bead0308ddb3ca8ba52874.svg";
export { ForwardRef as ReactComponent };